import type { SmartLinkResponse } from '@atlaskit/linking-types';

export const generatePlaceholderData = (
	url: string,
	restrictedName: string,
	name?: string | null,
): SmartLinkResponse | undefined => {
	return {
		meta: {
			auth: [],
			definitionId: 'watermelon-object-provider',
			product: 'townsquare',
			visibility: 'restricted',
			access: 'granted',
			key: 'watermelon-object-provider',
		},
		data: {
			'@context': {
				'@vocab': 'https://www.w3.org/ns/activitystreams#',
				atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
				schema: 'http://schema.org/',
			},
			generator: {
				'@type': 'Application',
				'@id': 'https://www.atlassian.com/#TeamCentral',
				name: 'Projects',
			},
			'@type': ['Object', 'atlassian:Project'],
			url,
			name: name || restrictedName,
		},
	};
};
